import { useDriveToStoreNavigation } from '@/components/driveToStore/common/hooks/useDriveToStoreNavigation';
import FootfallReport from '@/components/driveToStore/FootfallReport/FootfallReport';
import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors';

export default function FootfallReportPage() {
  const { country, activePoiId, entityId, entityType } = useDriveToStoreNavigation();
  const user = useGlobalStore(getUser);

  if (!activePoiId) {
    return null;
  }

  return (
    <FootfallReport
      activePoiId={activePoiId}
      country={country}
      entityId={entityId}
      entityType={entityType}
      userId={user.toJSON().id!}
    />
  );
}
